/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { idPassportAction } from 'shared/store/actions';
import Camera, { FACING_MODES, IMAGE_TYPES } from 'react-html5-camera-photo';
import CloseIcon from 'assets/icons/close.svg';
import { PATH } from 'shared/constant';
import 'react-html5-camera-photo/build/css/index.css';
import './TakePhoto.scss';
import classNames from 'classnames';
import { isMobileOnly } from 'react-device-detect';
import { Button } from 'components';
import ImagePreview from '../ImagePreview';

function TakePhoto(props) {
  const [dataUri, setDataUri] = useState('');
  const { location: { state } } = props;
  const classes = classNames({
    camera: true,
    'camera--mobile': isMobileOnly,
  });

  function handleTakePhotoAnimationDone(imgSrc) {
    setDataUri(imgSrc);
  }

  function handleClose() {
    props.history.push(PATH.ID_PASSPORT_SCANNING);
  }

  function handleRedo() {
    setDataUri('');
  }

  function handleOk() {
    props.onUpdateIdPassport(state.currentField, dataUri);
    props.history.push(PATH.ID_PASSPORT_SCANNING);
  }

  function handleCameraError(error) {
    console.log('camera error ', error);
  }

  const isFullscreen = isMobileOnly;
  return (
    <div className={classes}>
      {
        (dataUri)
          ? (
            <div className="camera__preview">
              <section className="camera__preview__content">
                <ImagePreview
                  dataUri={dataUri}
                />
              </section>
              <footer className="camera__preview__action">
                <Button value="Redo" isPrimary isOutlineButton onButtonClick={handleRedo} />
                <Button value="Ok" isPrimary onButtonClick={handleOk} />
              </footer>
            </div>
          )
          : (
            <>
              <Camera
                onTakePhotoAnimationDone={handleTakePhotoAnimationDone}
                onCameraError={error => handleCameraError(error)}
                isFullscreen={isFullscreen}
                idealFacingMode={state.currentField === 'selfie' ? FACING_MODES.USER : FACING_MODES.ENVIRONMENT}
                imageType={IMAGE_TYPES.JPG}
                isImageMirror={false}
                imageCompression={0.85}
                sizeFactor={1}
                idealResolution={{ width: 800, height: 480 }}
              />
              <img className="camera__close" src={CloseIcon} alt="close" onClick={handleClose} />
            </>
          )
      }
    </div>
  );
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  onUpdateIdPassport: (name, value) => dispatch(idPassportAction.updateIdPassportData(name, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TakePhoto);
